import ResendInviteLink from './ResendInviteLink'

export default ResendInviteLink
